module.exports = __webpack_public_path__ + "static/media/status.7ee34b72.jpg";